import { useProductName } from '../hooks/useProductName';

const ProductBrand = () => {
	const { blockClass, showBrandName, mzProductName } = useProductName();

	return (
		<span
			className={`productBrand productBrand--${blockClass} vtex-store-components-3-x-productBrand vtex-store-components-3-x-productBrand--${blockClass}`}
		>
			{`${mzProductName ?? 'Camiseta Branca Tamanho P'}`} {showBrandName && ' - Coca-Cola'}
		</span>
	);
};

export default ProductBrand;
